import { Box, Pagination, Stack, Theme, Typography, useMediaQuery } from "@mui/material";
import React, { ChangeEvent } from "react";

type Props = {
    page: number;
    take: number;
    totalCount: number;
    setPage: (skip: number) => void;
    showItemRange?: boolean;
};

const Paging = ({ page, take, totalCount, setPage, showItemRange }: Props) => {
    const totalPages = Math.ceil(totalCount / take);

    const handleChange = (_: ChangeEvent<unknown>, value: number) => {
        window.scrollTo({ top: 0, behavior: "smooth" });
        return setPage(value - 1);
    };

    const isSmallScreen = useMediaQuery((theme: Theme) =>
        theme.breakpoints.down("sm")
    );

    const startIndex = page * take + 1;
    const endIndex = Math.min((page + 1) * take, totalCount);

    return (
        <>
            {totalCount > take ? (
                <Stack spacing={2}>
                    {showItemRange && (
                        <Box sx={{ display: "flex", justifyContent: "center" }}>
                            <Typography variant="body2" color="text.secondary">
                                {startIndex}-{endIndex} / {totalCount}
                            </Typography>
                        </Box>
                    )}
                    <Pagination
                        count={totalPages}
                        page={page + 1}
                        onChange={handleChange}
                        shape="rounded"
                        color="primary"
                        size={isSmallScreen ? "small" : "large"}
                        showFirstButton
                        showLastButton
                        sx={{ p: 3 }}
                    />
                </Stack>
            ) : null}
        </>
    );
};

export default Paging;
